<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <div class="page-title-box d-sm-flex align-items-center justify-content-between">
        <h4 class="mb-sm-0">Products Management</h4>
        <div class="page-title-right">
          <ol class="breadcrumb m-0">
            <li class="breadcrumb-item"><a routerLink="/dashboard">Menu</a></li>
            <li class="breadcrumb-item active">Add Product</li>
          </ol>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-header align-items-center d-flex">
          <h4 class="card-title mb-0 flex-grow-1">Add Product</h4>
          <div class="flex-shrink-0">
            <a routerLink="/ecomm/products" class="btn btn-light me-2">Cancel</a>
            <button type="button" class="btn btn-primary" (click)="submit()">Add Product</button>
          </div>
        </div>
        <div class="card-body">
          <div class="row gy-4">
            <div class="col-xxl-6 col-md-6">
              <label class="form-label" for="productName">Name <span class="text-danger">*</span></label>
              <input type="text" class="form-control" id="productName" name="name" [(ngModel)]="form.name"
                     [ngClass]="{'is-invalid': !form.name && validationTriggered, 'is-valid': validationTriggered && form.name}">
            </div>
            <div class="col-xxl-6 col-md-6">
              <label class="form-label" for="brandId">Brand <span class="text-danger">*</span></label>
              <select class="form-select" id="brandId" name="brand_id" [(ngModel)]="form.brand_id"
                      [ngClass]="{'is-invalid': !form.brand_id && validationTriggered}">
                <option value="">Select brand</option>
                <option *ngFor="let brand of brands" [ngValue]="brand.id">{{ brand.name }}</option>
              </select>
            </div>
            <div class="col-xxl-6 col-md-6">
              <label class="form-label" for="categoryKey">Category</label>
              <select class="form-select" id="categoryKey" name="category_key" [(ngModel)]="form.category_key">
                <option value="">Select category</option>
                <optgroup label="Categories" *ngIf="categories.length">
                  <option *ngFor="let category of categories" [ngValue]="'c:' + category.id">{{ category.name }}</option>
                </optgroup>
                <optgroup label="SAP Categories" *ngIf="sapCategories.length">
                  <option *ngFor="let category of sapCategories" [ngValue]="'s:' + category.id">{{ category.name }}</option>
                </optgroup>
              </select>
            </div>
            <div class="col-xxl-6 col-md-6">
              <label class="form-label" for="groupId">Group ID</label>
              <input type="number" class="form-control" id="groupId" name="group_id" [(ngModel)]="form.group_id">
            </div>
            <div class="col-xxl-6 col-md-6">
              <label class="form-label" for="stockId">Stock ID <span class="text-danger">*</span></label>
              <input type="text" class="form-control" id="stockId" name="stock_id" [(ngModel)]="form.stock_id"
                     [ngClass]="{'is-invalid': !form.stock_id && validationTriggered, 'is-valid': validationTriggered && form.stock_id}">
            </div>
            <div class="col-xxl-6 col-md-6">
              <label class="form-label" for="barcode">Barcode <span class="text-danger">*</span></label>
              <input type="text" class="form-control" id="barcode" name="barcode" [(ngModel)]="form.barcode"
                     [ngClass]="{'is-invalid': !form.barcode && validationTriggered, 'is-valid': validationTriggered && form.barcode}">
            </div>
            <div class="col-xxl-6 col-md-6">
              <label class="form-label" for="sku">SKU <span class="text-danger">*</span></label>
              <input type="text" class="form-control" id="sku" name="sku" [(ngModel)]="form.sku"
                     [ngClass]="{'is-invalid': !form.sku && validationTriggered, 'is-valid': validationTriggered && form.sku}">
            </div>
            <div class="col-xxl-6 col-md-6">
              <label class="form-label" for="basePrice">Base Price <span class="text-danger">*</span></label>
              <input type="number" step="0.01" class="form-control" id="basePrice" name="base_price" [(ngModel)]="form.base_price"
                     [ngClass]="{'is-invalid': (form.base_price === '' || form.base_price === null) && validationTriggered, 'is-valid': validationTriggered && form.base_price !== '' && form.base_price !== null}">
            </div>
            <div class="col-xxl-6 col-md-6">
              <label class="form-label" for="productStatus">Status <span class="text-danger">*</span></label>
              <select class="form-select" id="productStatus" name="status" [(ngModel)]="form.status">
                <option [ngValue]="1">Active</option>
                <option [ngValue]="2">Inactive</option>
              </select>
            </div>
            <div class="col-12">
              <label class="form-label" for="description">Description</label>
              <textarea class="form-control" id="description" name="description" rows="3" [(ngModel)]="form.description"></textarea>
            </div>
            <div class="col-12">
              <label class="form-label" for="specialRemarks">Special Remarks</label>
              <textarea class="form-control" id="specialRemarks" name="special_remarks" rows="2" [(ngModel)]="form.special_remarks"></textarea>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
